/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'daily' }, { id: 'few' }, { id: 'weekly' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-wash-frequency"
      progress={60}
      field="hairstyleWashFrequency"
      setter="setHairstyleWashFrequency"
      ns="hairstyleWashFrequency"
      imageName="hairstyleWashFrequency"
      options={OPTIONS}
    />
  );
}

export default Page;
